
export function Ellipsized({ txt, num }: { txt: string, num: number }) {
    if (txt.length <= num) {
        return <>{txt}</>
    }
    return (
        <>{txt.substring(0, num - 1)}&hellip;</>
    )
}
